// src/menu/sections/monitorMenu.ts
import type { AppMenuEntry } from "../types";

export const WIKI_MENU: AppMenuEntry = {
  type: "group",
  key: "wiki-group",
  label: "Wiki",
  children: [
    {
      key: "wiki",
      label: "Wiki",
      path: "/wiki",
      componentKey: "wikiControl",
      icon: "wiki",
    },
    {
      key: "wiki-home",
      label: "Wiki:Home",
      href: "/wiki/home",
      icon: "home",
    },
    {
      key: "uvoo",
      label: "www.uvoo.io (External)",
      href: "https://www.uvoo.io",
      icon: "home",
      // optional: newTab true (external already implies new tab in code above)
      newTab: true,
    },
  ],
};
